<div class="card shadow contact-card">
    <div class="card-body">
        <form class="contact-form" [formGroup]="leadGenForm">

            <div class="row">
                <!-- Dynamic AdditionalInfo free text fields -->
                <ng-container *ngIf="additionalInfoExists">
                    <ng-container *ngFor="let key of getAdditionalInfoKeys()">
                        <div class="col-12 col-sm-12"
                             *ngIf="AdditionalInfo?.AdditionalInfoItem[key]?.QuestionTextArea !== undefined">
                            <p class="m-0 font-size-16">
                                <mat-form-field appearance="outline" class="w-100" floatLabel="never">
                                    <mat-label>{{ AdditionalInfo?.AdditionalInfoItem[key]?.QuestionTextArea }}</mat-label>
                                    <textarea rows="3" matInput #message maxlength="300"
                                        [formControlName]="'additionalInfoItem[' + key + ']'"
                                        placeholder="{{ AdditionalInfo?.AdditionalInfoItem[key]?.Placeholder }}">
                                    </textarea>
                                    <mat-hint align="end">{{message.value.length}} / 300</mat-hint>
                                    <mat-error *ngIf="leadGenForm.get('additionalInfoItem[' + key + ']')?.hasError('required')">
                                        {{ AdditionalInfo.AdditionalInfoItem[key].errorMessage ||
                                            ('Answer is required')
                                        }}
                                    </mat-error>
                                </mat-form-field>
                            </p>
                        </div>
                    </ng-container>
                </ng-container>

                <div class="col-12 col-sm-12" [class.col-md-6]="section?.columns <= 2">
                    <p class="m-0 font-size-16">
                        <mat-form-field appearance="outline" class="w-100" floatLabel="never">
                            <mat-label>First Name</mat-label>
                            <input matInput formControlName="firstName" placeholder="First Name">
                            <mat-error *ngIf="f.firstName.hasError('required')">First name is required</mat-error>
                            <mat-error *ngIf="f.firstName.hasError('minLength')">First name must be at least 2
                                characters</mat-error>
                            <mat-error *ngIf="f.firstName.hasError('pattern')">First name should only contain letters
                            </mat-error>
                        </mat-form-field>
                    </p>
                </div>

                <div class="col-12 col-sm-12" [class.col-md-6]="section?.columns <= 2">
                    <p class="m-0 font-size-16">
                        <mat-form-field appearance="outline" class="w-100" floatLabel="never">
                            <mat-label>Last Name</mat-label>
                            <input matInput formControlName="lastName" placeholder="Last Name">
                            <mat-error *ngIf="f.lastName.hasError('required')">Last name is required</mat-error>
                            <mat-error *ngIf="f.lastName.hasError('minLength')">Last name must be at least 2 characters
                            </mat-error>
                            <mat-error *ngIf="f.lastName.hasError('pattern')">Last name should only contain letters
                            </mat-error>
                        </mat-form-field>
                    </p>
                </div>

                <div class="col-12 col-sm-12" [class.col-md-6]="section?.columns <= 2">
                    <p class="m-0 font-size-16">
                        <mat-form-field appearance="outline" class="w-100" floatLabel="never">
                            <mat-label>Email Address</mat-label>
                            <input matInput formControlName="emailAddress" placeholder="Email Address">
                            <mat-error *ngIf="f.emailAddress.hasError('required')">Email is required</mat-error>
                            <mat-error *ngIf="f.emailAddress.hasError('pattern')">Email must be valid</mat-error>
                        </mat-form-field>
                    </p>
                </div>

                <div class="col-12 col-sm-12" [class.col-md-6]="section?.columns <= 2">
                    <p class="m-0 font-size-16">
                        <mat-form-field appearance="outline" class="w-100" floatLabel="never">
                            <mat-label>Contact number</mat-label>
                            <input matInput formControlName="phoneNumber" placeholder="Contact Number">
                            <mat-error *ngIf="f.phoneNumber.hasError('required')">Contact number is required</mat-error>
                            <mat-error *ngIf="f.phoneNumber.hasError('pattern')">Contact number must be numeric
                            </mat-error>
                        </mat-form-field>
                    </p>
                </div>

                <ng-container *ngIf="!courseKeyExists">
                <div class="col-12 col-sm-12" [class.col-md-6]="section?.columns <= 2">
                    <p class="m-0 font-size-16">
                        <mat-form-field appearance="standard" class="w-100 mat-custom-select" floatLabel="never">
                            <mat-select class="py-6 px-4 rounded" placeholder="Select institute"
                                style="border: 1px solid #cdd6df;" formControlName="institute">
                                <mat-option value="">Select Institute</mat-option>
                                <mat-option [value]="institute" *ngFor="let institute of courses">{{ institute?.short_title }}</mat-option>
                            </mat-select>

                            <mat-error *ngIf="f.institute.hasError('required')">Institute is required</mat-error>
                        </mat-form-field>
                    </p>
                </div>
                </ng-container>

                <!-- Dynamic AdditionalInfo select fields -->
                <ng-container *ngIf="additionalInfoExists">
                    <ng-container *ngFor="let key of getAdditionalInfoKeys()">
                    <div class="col-12 col-sm-12"
                         [class.col-md-6]="section?.columns <= 2"
                         *ngIf="AdditionalInfo?.AdditionalInfoItem[key]?.Question !== undefined">
                        <p class="m-0 font-size-16">
                            <mat-form-field appearance="standard" class="w-100 mat-custom-select" floatLabel="never">
                                <mat-select class="py-6 px-4 rounded" style="border: 1px solid #cdd6df;"
                                        placeholder="Select answer for question"
                                        [formControlName]="'additionalInfoItem[' + key + ']'">
                                    <mat-option value=""
                                            [matTooltip] = "AdditionalInfo?.AdditionalInfoItem[key]?.Question"
                                            matTooltipPosition="above">
                                        {{ AdditionalInfo?.AdditionalInfoItem[key]?.Question }}
                                    </mat-option>
                                    <mat-option *ngFor="let answer of AdditionalInfo?.AdditionalInfoItem[key]?.Answers"
                                            [matTooltip] = "answer.Value"  matTooltipPosition="above"
                                            [value]="answer.Value">
                                        {{ answer.Value }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="leadGenForm.get('additionalInfoItem[' + key + ']')?.hasError('required')">
                                    {{ AdditionalInfo.AdditionalInfoItem[key].errorMessage ||
                                        ('Answer is required')
                                    }}
                                </mat-error>
                            </mat-form-field>
                        </p>
                    </div>
                    </ng-container>
                </ng-container>

                <div class="col-12 col-sm-12">
                    <p class="mt-5 mb-10 font-size-13">
                        <mat-checkbox formControlName="subscribe">I would like to receive course related updates, news
                            and promotional information from IBTC.</mat-checkbox>
                    </p>
                </div>

                <div class="col-12 col-sm-12">
                    <div class="form-group">
                        <button type="button" *ngIf="!processing" (click)="saveChanges()"
                            class="btn btn-lg rounded-pill font-size-16 font-weight-bold btn-primary btn-block">
                            Submit
                        </button>

                        <div *ngIf="processing" class="d-flex justify-content-center align-items-center preloader">
                            <mat-spinner diameter="24"></mat-spinner>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-sm-12">
                    <p class="text-center" style="font-size: 12px; color: #828b91;">Please note that it can take up to 2
                        working days to receive an answer.</p>
                </div>

                <div class="d-flex align-items-center justify-content-center w-100" *ngIf="success">
                    <div class="d-inline-flex">
                    <img loading="lazy" src="assets/img/icons/icn-check-green.svg" class="mr-3" /> <span
                        class="font-size-16">Successfully sent your message!</span>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>